import {takeLatest, put} from 'redux-saga/effects';
import {actions} from '../slices/GrowthStatictisSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';



function* getGrowthStatictis({payload: {filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/growth`, {
            params: {
                ...filters,
            }
        });
        yield put({type: actions.get_growth_statistic_succeed.type, payload: {...response.data}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.get_growth_statistic_failed.type, payload: error});
    }
}






function* watchRequestDetail() {
    yield takeLatest(actions.get_growth_statistic.type, getGrowthStatictis);    
}

export default watchRequestDetail;